export default __webpack_public_path__ + "static/media/tree.bf71a966.webp";